import React from "react";
import { Row} from "reactstrap";
import ReactPlayer from "react-player";
//import { hot } from 'react-hot-loader'

class Video extends React.Component {
  ref = player => {
    this.player = player;
  };
  render() {
    const {url} = this.props;
    return (
        <Row className="text-center">
          <ReactPlayer
            config={{
              youtube: {
                playerVars: { 
                  showinfo: 0,
                  autoplay: 0,
                  cc_load_policy: 1,
                  playsinline: 0
                },       
              },
            }}
            ref={this.ref}
            width="100%"
            //height="100%"
            controls={true}
            url={url}
            onStart={this.props.onStart}
          />
        </Row>
    );
  }
}
//export default hot(module)(Video)
export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js